import { SsoType } from '@diritto/common/account/constants/sso.constant';
import FirebaseAnalytics, {
  getAnalytics,
  initializeAnalytics,
  logEvent,
  setUserId,
  setUserProperties,
} from '@firebase/analytics';
import { initializeApp } from '@firebase/app';
import BaseTracker from 'trackers/BaseTracker';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

export class FirebaseTracker extends BaseTracker {
  tracker!: FirebaseAnalytics.Analytics;

  constructor() {
    super();

    this.initialize();
  }

  protected getTracker(): any {
    return super.getTracker();
  }

  initialize() {
    if (typeof window === 'undefined') {
      return;
    }

    if (!this.initialized) {
      const app = initializeApp(firebaseConfig, 'diritto-web');
      const analyticsApp = getAnalytics(app);
      const analytics = initializeAnalytics(analyticsApp.app);
      this.tracker = analytics;

      this.initialized = true;
    }
  }

  logSignUp(userId: number, ssoType: SsoType) {
    logEvent(this.tracker, 'sign_up', { method: ssoType });
    setUserId(this.tracker, `${userId}`);
  }

  logLogin(userId: number, ssoType: SsoType) {
    logEvent(this.tracker, 'login', { method: ssoType });
    setUserProperties(this.tracker, { method: ssoType });
    setUserId(this.tracker, `${userId}`);
  }

  track(event: string, params?: { [key: string]: any }) {
    try {
      logEvent(this.tracker, event.toLowerCase().replace(/\s+/g, '_'), flattenObject(params ?? {}));
    } catch (e) {
      console.error(e);
    }
  }
}

function flattenObject(obj: any, parent?: string, res: any = {}) {
  // eslint-disable-next-line guard-for-in
  for (const key in obj) {
    const propName = parent ? `${parent}_${key}` : key;
    if (typeof obj[key] === 'object') {
      flattenObject(obj[key], propName, res);
    } else {
      res[propName] = obj[key];
    }
  }
  return res;
}

export default FirebaseTracker;
